/**
 * Global error handler registry for API factories.
 *
 * The app shell configures this once at startup so that all hooks created
 * via createEntityQuery/createEntityMutation automatically get error toasting.
 *
 * This keeps @packages/api-client dependency-free — the actual toast logic
 * lives in the app shell where notify/Toast are available.
 */

type ErrorHandler = (error: unknown) => void;

let registeredHandler: ErrorHandler | null = null;

/**
 * Register a global error handler that factories will call on API errors.
 * Call this once in the app shell during initialization.
 *
 * @example
 * // src/apps/customer/components/AppShell/index.tsx
 * import { registerGlobalErrorHandler } from '@packages/api-client';
 * import { showApiErrorToast } from '@packages/shared/utils';
 *
 * registerGlobalErrorHandler(showApiErrorToast);
 */
export function registerGlobalErrorHandler(handler: ErrorHandler): void {
  registeredHandler = handler;
}

/**
 * Called by createEntityQuery/createEntityMutation when an API call fails.
 * If no handler is registered, errors pass through silently (factory still throws).
 */
export function handleFactoryError(error: unknown): void {
  registeredHandler?.(error);
}
